const AppErrorMessages = [
  {
    message: 'activity-schedule-conflict',
    ptBr: 'Já existe evento nesse horário para a mesma modalidade e nível de experiência.',
  },
  {
    message: 'activity-schedule-item-quantity-unavailable',
    ptBr: 'Não há mais vagas disponíveis para algum dos opcionais selecionados.',
  },
  {
    message: 'activity-not-found',
    ptBr: 'Atividade não encontrada.',
  },
  {
    message: 'cnpj-already-in-use',
    ptBr: 'CNPJ já está em uso.',
  },
  {
    message: 'email-already-in-use',
    ptBr: 'E-mail já está em uso.',
  },
  {
    message: 'insufficient-privilege',
    ptBr: 'Não autorizado.',
  },
  {
    message: 'schedule-already-booked',
    ptBr: 'Já existe reserva ativa para essa atividade.',
  },
  {
    message: 'spot-already-booked',
    ptBr: 'Já existe reserva ativa para esse local.',
  },
  {
    message: 'user-already-queued',
    ptBr: 'Já existe reserva na fila para esse evento.',
  },
  {
    message: 'venture-not-found',
    ptBr: 'Empreendimento não encontrado.',
  },
  {
    message: 'venture-address-missing',
    ptBr: 'Cadastro do empreendimento inclompleto, defina um endereço.',
  },
  {
    message: 'venture-phone-missing',
    ptBr: 'Cadastro do empreendimento inclompleto, defina um número de telefone.',
  },
  {
    message: 'venture-ref-already-in-use',
    ptBr: 'Ref já está em uso.',
  },
  {
    message: 'cpf-already-in-use-on-venture',
    ptBr: 'CPF já está em uso no empreendimento.',
  },
  {
    message: 'email-already-in-use-on-venture',
    ptBr: 'E-mail já está em uso no empreendimento.',
  },
  {
    message: 'foreigner-document-already-in-use-on-venture',
    ptBr: 'Documento já está em uso no empreendimento.',
  },
  {
    message: 'cpf-already-in-use',
    ptBr: 'CPF já está em uso.',
  },
  {
    message: 'foreigner-document-already-in-use',
    ptBr: 'Documento já está em uso.',
  },
  {
    message: 'feature-key-already-registered',
    ptBr: 'Chave já está em uso.',
  },
  {
    message: 'feature-name-already-registered',
    ptBr: 'Nome já está em uso.',
  },
  {
    message: 'user-not-found',
    ptBr: 'Usuário não encontrado.',
  },
  {
    message: 'user-max-day-bookings',
    ptBr: 'Limite de reservas diárias atingido.',
  },
  {
    message: 'user-guest-max-day-bookings',
    ptBr: 'Limite de reservas diárias de convidados atingido.',
  },
  {
    message: 'user-category-has-users-assigned',
    ptBr: 'Existem membros vinculados à essa categoria.',
  },
  {
    message: 'host-blocked',
    ptBr: 'Responsável bloqueado.',
  },
  {
    message: 'titular-blocked',
    ptBr: 'Titular bloqueado.',
  },
  {
    message: 'user-blocked',
    ptBr: 'Usuário bloqueado.',
  },
  {
    message: 'past-start-time',
    ptBr: 'Hora inicial passada.',
  },
  {
    message: 'overlapping-time-range',
    ptBr: 'Intervalo de horário sobrepondo outra reserva.',
  },
  {
    message: 'booking-no-vacancies-available',
    ptBr: 'Não há vagas disponíveis.',
  },
  {
    message: 'guest-booking-no-vacancies-available',
    ptBr: 'Não há vagas disponíveis para convidados.',
  },
  {
    message: 'lodger-booking-no-vacancies-available',
    ptBr: 'Não há vagas disponíveis para hóspedes.',
  },
  {
    message: 'booking-time-range-invalid',
    ptBr: 'Intervalo de horário fora dos limites do evento.',
  },
  {
    message: 'invalid-amount',
    ptBr: 'Valor inválido, confira o saldo.',
  },
  {
    message: 'user-address-missing',
    ptBr: 'Usuário sem endereço cadastrado.',
  },
  {
    message: 'user-birth-date-missing',
    ptBr: 'Usuário sem data de nascimento cadastrada.',
  },
  {
    message: 'user-cpf-missing',
    ptBr: 'Usuário sem CPF cadastrado.',
  },
  {
    message: 'user-phone-missing',
    ptBr: 'Usuário sem telefone cadastrado.',
  },
  {
    message: 'booking-payment-pending',
    ptBr: 'Pagamento pendente, realize o pagamento para fazer check-in.',
  },
  {
    message: 'booking-payment-register-failed',
    ptBr: 'Falha ao criar pedido nos meios de pagamento.',
  },
  {
    message: 'has-bookings-pending',
    ptBr: 'Existem reservas pendentes.',
  },
  {
    message: 'schedule-finished',
    ptBr: 'Evento finalizado.',
  },
  {
    message: 'user-venture-onboard-not-found',
    ptBr: 'Onboard de usuário não finalizado.',
  },
  {
    message: 'booking-cancellation-reason-required',
    ptBr: 'Motivo de cancelamento requerido.',
  },
  {
    message: 'booking-invoice-config-not-found',
    ptBr: 'Configurações fiscais de reservas não definidas nessa atividade, revise as configurações da atividade.',
  },
  {
    message: 'guest-invoice-config-not-found',
    ptBr: 'Configurações fiscais de reservas de convidados não definidas nessa atividade, revise as configurações da atividade.',
  },
  {
    message: 'has-pending-activity-schedules-with-price',
    ptBr: 'Existem sessões com preço de reserva nessa atividade, para remover as informações fiscais edite as sessões removendo o preço de reserva.',
  },
  {
    message: 'has-pending-activity-schedules-with-guest-price',
    ptBr: 'Existem sessões com preço de reserva de convidados nessa atividade, para remover as informações fiscais edite as sessões removendo o preço de reserva de convidados.',
  },
  {
    message: 'appointment-readonly-status',
    ptBr: 'Ordem de serviço em status de somente leitura.',
  },
  {
    message: 'financial-report-export-too-large',
    ptBr: 'O relatório possui muitos registros. Reduza o período do filtro e tente exportar novamente.',
  },
];

interface ITRanslateErrorProps {
  message: string;
  language?: 'ptBr';
}

export const translateError = ({
  message,
  language = 'ptBr',
}: ITRanslateErrorProps): string | undefined =>
  AppErrorMessages.find((errorMessage) => errorMessage.message === message)?.[
    language
  ];

export const getResponseErrorMessage = async (
  data: unknown,
): Promise<string | undefined> => {
  if (data instanceof Blob) {
    const text = await data.text();

    try {
      const parsedData = JSON.parse(text) as { message?: string };

      return parsedData.message;
    } catch {
      return undefined;
    }
  }

  return (data as { message?: string } | undefined)?.message;
};
